<div class="container-inner">
  <app-connect-device
    *ngIf="userData && userData.device_type == null"
  ></app-connect-device>
  <div class="row" *ngIf="pageViewed == false">
    <div class="col-12 col-md-6 offset-md-3" *ngIf="userData">
      <h4 class="text-center mt-4 mb-2">Move Well Videos</h4>
      <div class="card bg-light">
        <div class="card-body">
          <ul class="link-list">
            <li>
              <a [routerLink]="['/activity', 'resources', 1]">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">Welcome to Move Well</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/activity', 'resources', 2]">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">How to Move Safely</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/activity', 'device-faqs']">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label"
                  >How to use the wearable pedometer watch</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <h2 class="text-center my-3 title-light">
    <span class="lighter">Please select an area...</span>
  </h2>

  <div class="row" *ngIf="userData">
    <div class="col-6">
      <div class="index-selection-card card mb-4 rounded bg-dark text-white">
        <img
          src="/assets/img/move-well-prep-steps-457x300.jpg"
          class="card-img-top"
          alt="..."
        />

        <div class="card-body text-center pb-1">
          <div class="card-masthead">
            <span class="icon-wrap"
              ><fa-icon [icon]="['fas', 'walking']"></fa-icon
            ></span>
            <h2>Prep Steps</h2>
          </div>

          <div *ngIf="isLoading" class="spinning-loader">
            <app-loading-spinner
              [inline]="1"
              [size]="'small'"
            ></app-loading-spinner>
          </div>
          <ng-container *ngIf="!isLoading">
            <div class="text-center" *ngIf="allSteps && allSteps.length > 0">
              <ng-container *ngIf="stepTarget">
                <h4 class="card-subtitle">Today</h4>
                <div class="card-total">
                  <span class="text-primary">{{ todaySteps | number }}</span> /
                  {{ stepTarget.target | number }}
                </div>
                <div class="days-indicator days-indicator-sm">
                  <div class="day" *ngFor="let day of stepWeekData">
                    <div class="day-label">
                      {{ day.date | customDate : "dddd" | slice : 0 : 1 }}
                    </div>
                    <div
                      class="day-status"
                      [ngClass]="{
                        'bg-danger':
                          +day.steps < +stepTarget.target && day.date < today,
                        'bg-primary': +day.steps > +stepTarget.target
                      }"
                    ></div>
                  </div>
                </div>

                <p class="card-info mt-1 mb-1">
                  Hit your daily steps target every day
                </p>
              </ng-container>
              <ng-container *ngIf="!stepTarget">
                <p class="card-info mb-2">Please set a daily step target.</p>
                <form name="stepTargetForm" #stepTargetForm="ngForm">
                  <div class="row">
                    <div class="col-md-4 offset-md-1">
                      <div class="form-group">
                        <label for="mins">Steps Per Day</label>
                        <input
                          type="number"
                          name="targetSteps"
                          class="form-control form-control-sm"
                          placeholder="e.g. 8000"
                          id="targetSteps"
                          [ngModel]
                          #targetSteps="ngModel"
                          [min]="1"
                          [max]="15000"
                          autocomplete="off"
                        />

                        <div
                          class="alert alert-danger"
                          *ngIf="targetSteps.touched && targetSteps.invalid"
                        >
                          This must be a number between 1 and 15000.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <button
                      (click)="submitStepTarget()"
                      class="btn btn-primary btn-sm w-100"
                      [disabled]="targetSteps.invalid"
                    >
                      SET TARGET
                    </button>
                  </div>
                </form>
              </ng-container>
            </div>

            <div
              class="card-text text-center mb-1"
              *ngIf="allSteps && allSteps.length == 0"
            >
              Increase your baseline level of physical activity before surgery
              by walking to hit daily step targets.
            </div>
            <a [routerLink]="['/activity', 'steps']" class="stretched-link"
              ><span class="icon-wrap more-link text-primary"
                ><fa-icon
                  [icon]="['fas', 'circle-chevron-right']"
                ></fa-icon></span
            ></a>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="index-selection-card card mb-4 rounded bg-dark text-white">
        <img
          src="/assets/img/move-well-prep-fit-457x300.jpg"
          class="card-img-top"
          alt="..."
        />
        <div class="card-body text-center pb-1">
          <div class="card-masthead">
            <span class="icon-wrap"
              ><fa-icon [icon]="['fas', 'running']"></fa-icon
            ></span>
            <h2>Prep Fit</h2>
          </div>

          <div *ngIf="isLoading" class="spinning-loader">
            <app-loading-spinner
              [inline]="1"
              [size]="'small'"
            ></app-loading-spinner>
          </div>

          <div *ngIf="!isLoading">
            <div *ngIf="allCardioWorkouts && allCardioWorkouts.length > 0">
              <h4 class="card-subtitle">Level</h4>
              <div class="card-total">
                <span class="text-primary">{{ userData.fit_level }}</span> / 3
              </div>

              <div class="card-progress">
                <div class="card-progress-title">
                  {{ cardioMinsWeek }} MINS COMPLETED
                </div>
                <div class="progress progress-sm">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style="width: {{ cardioProgress }}%"
                    [attr.aria-valuenow]="cardioProgress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>

              <p class="card-info mt-1 mb-1">
                150 minutes of moderate exercise over 7 days
              </p>
            </div>
            <div
              class="card-text text-center mb-1"
              *ngIf="allCardioWorkouts && allCardioWorkouts.length == 0"
            >
              Do aerobic training sessions to unlock and complete each of the
              three programme levels.
            </div>
          </div>

          <a [routerLink]="['/activity', 'fit']" class="stretched-link"
            ><span class="icon-wrap more-link text-primary"
              ><fa-icon
                [icon]="['fas', 'circle-chevron-right']"
              ></fa-icon></span
          ></a>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="userData">
    <div class="col-6">
      <div class="index-selection-card card mb-4 rounded bg-dark text-white">
        <img
          src="/assets/img/move-well-prep-strong-457x300.jpg"
          class="card-img-top"
          alt="..."
        />
        <div class="card-body text-center pb-1">
          <div class="card-masthead">
            <span class="icon-wrap"
              ><fa-icon [icon]="$any(['fac', 'lunge'])"></fa-icon
            ></span>
            <h2>Prep Strong</h2>
          </div>

          <div *ngIf="!isLoading" class="spinning-loader">
            <div *ngIf="allMoveWorkouts && allMoveWorkouts.length > 0">
              <h4 class="card-subtitle">Level</h4>
              <div class="card-total">
                <span class="text-primary">{{ userData.move_level }}</span> / 3
              </div>

              <div class="days-indicator days-indicator-sm">
                <div class="day" *ngFor="let day of moveWeekData">
                  <div class="day-label">
                    {{ day.date | customDate : "dddd" | slice : 0 : 1 }}
                  </div>
                  <div
                    class="day-status"
                    [ngClass]="{ 'bg-primary': day.total_reps >= 144 }"
                  >
                    <span
                      class="dot"
                      *ngIf="day.total_reps > 0 && day.total_reps < 144"
                    ></span>
                  </div>
                </div>
              </div>

              <p class="card-info mt-1 mb-1">2 or more sessions per week</p>
            </div>
            <div
              class="card-text text-center mb-1"
              *ngIf="allMoveWorkouts && allMoveWorkouts.length == 0"
            >
              Increase muscular strength and endurance to support functional
              movements after surgery by completing strength training workouts.
            </div>
          </div>
          <a [routerLink]="['/activity', 'move']" class="stretched-link"
            ><span class="icon-wrap more-link text-primary"
              ><fa-icon
                [icon]="['fas', 'circle-chevron-right']"
              ></fa-icon></span
          ></a>
        </div>
      </div>
    </div>
    <div class="col-6" *ngIf="userData && userData.block_breathewell != 1">
      <div class="index-selection-card card mb-4 rounded bg-dark text-white">
        <img
          src="/assets/img/move-well-breathe-well-457x300.jpg"
          class="card-img-top"
          alt="..."
        />
        <div class="card-body text-center pb-1">
          <div class="card-masthead">
            <span class="icon-wrap icon-lungs"
              ><fa-icon [icon]="['fas', 'lungs']"></fa-icon
            ></span>
            <h2>Breathe Well</h2>
          </div>

          <div *ngIf="!isLoading" class="spinning-loader">
            <div *ngIf="allBreathWorkouts && allBreathWorkouts.length > 0">
              <ng-container *ngIf="currentBreathLevel">
                <h4 class="card-subtitle">Load</h4>
                <div class="card-total">
                  <span class="text-primary">{{ currentBreathLevel }}</span> /
                  106
                </div>
              </ng-container>
              <div class="days-indicator days-indicator-sm">
                <div class="day" *ngFor="let day of breatheWeekData">
                  <div class="day-label">
                    {{ day.date | customDate : "dddd" | slice : 0 : 1 }}
                  </div>
                  <div
                    class="day-status mb-1"
                    [ngClass]="{
                      'bg-primary': day.am.breaths > 0,
                      'bg-white': day.am.breaths < 1
                    }"
                  ></div>
                  <div
                    class="day-status"
                    [ngClass]="{
                      'bg-primary': day.pm.breaths > 0,
                      'bg-white': day.pm.breaths < 1
                    }"
                  ></div>
                </div>
              </div>

              <p class="card-info mt-1 mb-1">2 sessions every day</p>
            </div>
            <div
              class="card-text text-center mb-1"
              *ngIf="allBreathWorkouts && allBreathWorkouts.length == 0"
            >
              Reduce the risk of postoperative complications through IMT
              training, which consists of twice daily practice to increase your
              load level.
            </div>
          </div>
          <a [routerLink]="['/activity', 'breathe']" class="stretched-link"
            ><span class="icon-wrap more-link text-primary"
              ><fa-icon
                [icon]="['fas', 'circle-chevron-right']"
              ></fa-icon></span
          ></a>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="pageViewed == true">
    <div class="col-12 col-md-6 offset-md-3" *ngIf="userData">
      <h4 class="text-center mt-4 mb-2">Move Well Videos</h4>
      <div class="card bg-light">
        <div class="card-body">
          <ul class="link-list">
            <li>
              <a [routerLink]="['/activity', 'resources', 1]">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">Welcome to Move Well</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/activity', 'resources', 2]">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label">How to Move Safely</span>
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/activity', 'device-faqs']">
                <span class="icon-wrap more-link text-dark"
                  ><fa-icon [icon]="['fas', 'play-circle']"></fa-icon
                ></span>
                <span class="link-label"
                  >How to use the wearable pedometer watch</span
                >
                <span class="icon-wrap more-link duo-primary-dark"
                  ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
                ></span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
